import { render, staticRenderFns } from "./PromotionReviewMenu.vue?vue&type=template&id=889e08ac&"
import script from "./PromotionReviewMenu.vue?vue&type=script&lang=js&"
export * from "./PromotionReviewMenu.vue?vue&type=script&lang=js&"
import style0 from "./PromotionReviewMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionReviewMenu.vue"
export default component.exports